import { useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

export const CompactLanguageSelector = () => {
  const { language, changeLanguageAndNavigate, languageNames, languageFlags } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang: string) => {
    changeLanguageAndNavigate(lang as any);
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm"
          className={cn(
            "h-9 px-3 text-xs font-medium",
            "hover:bg-accent transition-colors"
          )}
          aria-label="Change language"
        >
          <span className="text-sm mr-1">
            {languageFlags[language as keyof typeof languageFlags]}
          </span>
          <span className="hidden sm:inline-block font-medium">
            {language.toUpperCase()}
          </span>
          <ChevronDown className="h-3 w-3 ml-1 transition-transform duration-200" />
        </Button>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent 
        align="end" 
        className="min-w-[140px] bg-background border z-50"
      >
        {Object.entries(languageNames).map(([code, name]) => (
          <DropdownMenuItem 
            key={code}
            onClick={() => handleLanguageChange(code)}
            className={cn(
              "flex items-center gap-2 cursor-pointer transition-colors",
              language === code && "bg-primary/10 text-primary font-medium"
            )}
          >
            <span className="text-sm">
              {languageFlags[code as keyof typeof languageFlags]}
            </span>
            <span className="text-sm">{name}</span>
            {language === code && (
              <span className="ml-auto text-primary">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};